<template>
    <div class="funnel">
        <h2>
            <router-link to="/funnels" class="icon">
                <font-awesome-icon icon="chevron-left" /> &nbsp; Back
            </router-link>
            <input type="text" v-model="funnel.name" @change="app.saveFunnel(funnel)">
        </h2>

        <ul class="steps">
            <li v-for="step in funnel.steps" :class="'step step-' + step.status" :key="'step-' + step.id + Math.random()">
                <a @click="app.editStep(funnel, step)" href="javascript:;" class="link">Edit Message</a>

                <strong>
                    <span v-if="!int(step.delta)">Immediately,</span>
                    <span v-if="int(step.delta) < 0">{{Math.abs(step.delta)}} days before,</span>
                    <span v-if="int(step.delta) > 0">After {{Math.abs(step.delta)}} days,</span>
                </strong>

                <template v-if="step.action === 'email'">
                    <span> send "{{(step.message || {}).subject}}" email</span>
                </template>

                <template v-if="step.action === 'switch'">
                    <span> switch to the "{{app.tryKey(app.findById(app.funnels, step.funnelId), 'name', 'Not Found')}}" funnel</span>
                </template>
            </li>

            <li class="align-center">
                <button class="outline" @click="addStep()">
                    + Add Step
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
function SORT_BY_DELTA(a, b) {
    if (parseInt(a.delta) > parseInt(b.delta)) return  1;
    if (parseInt(a.delta) < parseInt(b.delta)) return -1;
    return 0;
}

export default {
    props: ['app'],
    computed: {
        funnel() {
            var _ = this,
                id = _.$route.params.id,
                funnel = _.app.funnels.find(function(funnel) {
                    return funnel.id + '' === id + '';
                });

            funnel.steps = (funnel.steps || []).sort(SORT_BY_DELTA);

            return funnel;
        }
    },
    methods: {
        addStep() {
            var _ = this,
                steps = (_.funnel.steps || []).sort(SORT_BY_DELTA),
                lastStep = steps[steps.length - 1],
                step = {
                    action: 'email',
                    delta: lastStep ? (parseInt(lastStep.delta) || 0) + 3 : 0,
                    message: {},
                    funnelId: '',
                    status: 'publish'
                };

            _.funnel.steps.push(step);
            _.app.editStep(_.funnel, step);
        },

        int(n) {
            return parseInt(n);
        }
    }
};
</script>
